<template>
    <div class="table-user">
        <template>
            <div class="table-user-header">
                <b-row class="pb-3">
                    <search-field @searchValue="searchField($event)"></search-field>
                    <date-filters @dateFromAction="filterTable($event)" @dateToAction="filterTable($event)" />
                </b-row>
            </div>
            <div class="scroll-x">
                <table-element
                    :items="items"
                    :fields="fields"
                    :status="options.status"
                    @statusFiltered="event => filterTable(event)"
                    @sort="event => sortTable(event)">
                    <select-filter slot="HEAD_service"
                                   name="salesChannel-select-filter"
                                   filterType="service"
                                   slot-scope="data"
                                   :options="options.salesChannel"
                                   placeholder="E-commerce"
                                   @statusFiltered="event => filterTable(event)"
                                   @filtered="event => filterTable(event)"/>
                    <template slot="orderParcels" slot-scope="data">
                        <p v-for="(item, index) in data.value" :key="item.id" class="mb-2">
                            Package {{index + 1}}:&nbsp;
                            <span v-text="item.weight + ' kg;'"></span>&nbsp;
                            <span v-text="item.length + '*' + item.width + '*' + item.height + ' cm;'"></span>
                        </p>
                    </template>
                    <template slot="service" slot-scope="data">
                        <img :src="`/static/brand/${data.item.service}.png`"
                            class="img-fluid shop-logo"
                            :alt="`image-${data.item.service}`">
                    </template>
                    <div slot="actions"
                         slot-scope="data" class="d-flex align-items-center">
                        <b-btn variant="primary-user"
                               class="text-nowrap"
                               :to="{name: 'SingleOrder', params: {orderId: data.item.id, parentBred: {route: $route}}}">
                            Open order details
                        </b-btn>
                        <b-btn v-if="data.item.status === 'inventory_reserved'"
                               variant="danger"
                               class="ml-2 text-nowrap"
                               @click="$root.$emit('bv::show::modal', `confirm-modal-${data.item.id}`)">
                            Cancel order
                        </b-btn>
                        <confirm-modal :id="data.item.id" @confirm="cancelOrder(data.item.id)"/>
                    </div>
                </table-element>
            </div>

            <div class="table-user-footer">
                <table-pagination
                    v-if="settingsPaginationFromApi.total >= quantityProductOnPage"
                    @paginateAction="updatePagination"
                    :settings="settingsPaginationFromApi"
                    :perPageArray="quantityProductVariations"/>
            </div>
        </template>
    </div>
</template>

<script>
    import {tableMixins, paginationMixin, routePaginationMixin} from '@/mixins/tableMixins'

    import TableElement from '~cp/UserPanel/Elements/TableElement'
    import SelectFilter from '~cp/UserPanel/Elements/TableSelectField'
    import StatusSelect from '~cp/UserPanel/Elements/StatusSelect'
    import SearchField from '~cp/UserPanel/Elements/SearchField'
    import DateFilters from '~cp/UserPanel/Elements/DateFilters'

    import ordersConfirm from '@/assets/js/columns/ordersConfirm'
    import ordersList from '@/assets/js/columns/ordersList'
    import {ordersList as ordersFilterOptions} from '@/assets/js/table-options/orders'

    import TablePagination from '~cp/UserPanel/Elements/TablePagination'

    import ConfirmModal from '~cp/UserPanel/Modals/ConfirmModal'

    export default {
        name: 'OrderList',
        mixins: [tableMixins, paginationMixin, routePaginationMixin],
        components: {
            TableElement,
            StatusSelect,
            SelectFilter,
            SearchField,
            DateFilters,
            TablePagination,
            ConfirmModal
        },
        data() {
            return {
                endpoint: this.$endpoints.orders.list,
                requiredApiParams: {
                    'filter[status:notIn]': 'new,unshipped,shipped,sent,delivered,closed',
                    'sort[fulfillmentDate]': 'desc'
                },
                options: ordersFilterOptions,
                fields: [...ordersConfirm, ...ordersList],
            }
        },
        computed: {},
        methods: {
            cancelOrder(id) {
                this.$store.dispatch('cancelOrder', id).then(() => this.getItems)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .table-user {
        min-height: 300px;
        .scroll-x {
            min-height: calc(100vh - 276px);
        }
    }
    .shop-logo {
        max-width: 80px;
    }
</style>



// WEBPACK FOOTER //
// src/components/UserPanel/Pages/Orders/Orders.vue